import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  TextField
} from '@mui/material';
import { useState } from 'react';

import useReports from '@/pages/Reports/Reports.hooks';

import type { ReportTitleEditDialogTypes } from './ReportTitleEditDialog.types';

const ReportTitleEditDialog = (props: ReportTitleEditDialogTypes) => {
  const { open, setOpen, selectedReport } = props;
  const { updateReport } = useReports();
  // Dialog is keyed by report id at the call site, so the draft never
  // outlives the report it was typed against.
  const [draft, setDraft] = useState<string | null>(null);
  const newTitle = draft ?? selectedReport?.report_title ?? '';
  const setNewTitle = setDraft;

  return (
    <Dialog fullWidth maxWidth="xs" onClose={() => setOpen(false)} open={open}>
      <DialogTitle>Edit Report Title</DialogTitle>
      <DialogContent>
        <InputLabel sx={{ pt: 2 }}>Report Title</InputLabel>
        <TextField
          value={newTitle}
          fullWidth
          onChange={(e) => setNewTitle(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false);
            setDraft(null);
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={!newTitle}
          onClick={() => {
            updateReport({
              report_id: selectedReport?.id as number,
              new_report_name: newTitle
            });
            setOpen(false);
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReportTitleEditDialog;
